<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t(titulo || "Detalhes da Medida Socioeducativa") }}
    </h1>
    <load v-if="loading" :mode="mode" />
    <div v-else id="boxPrint" class="row">
      <div class="col-md-12">
        <print-header />
        <table class="table table-bordered bg-white table-sm">
          <tbody>
            <tr>
              <td>
                ID:<b>{{ item.id }}</b> Protocolo:<b>{{ item.protocolo }}</b>
              </td>
              <td>
                Criado:<b>{{ item.cadastrado }}</b>
              </td>
            </tr>
            <tr>
              <td>
                Técnico Responsável:
                <b v-if="item.responsavel">
                  {{ item.responsavel.name }}
                </b>
              </td>
              <td>
                Atualizado: <b>{{ item.atualizado }}</b>
              </td>
            </tr>
            <tr>
              <td>
                Técnico autor:
                <b>{{ item.autor }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Outros técnicos:
                <b v-for="(tecnico, index) in item.outros_tecnicos">
                  {{ tecnico.nome }}
                  <span v-if="index < item.outros_tecnicos.length - 1">, </span>
                </b>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Unidade:
                <b v-if="item.unidade">
                  {{ item.unidade.nome }}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">
          Identificação do adolescente
        </h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
          <tbody>
            <tr>
              <td>
                Nome:
                <b>{{ item.usuario_nome }} </b>
              </td>
              <td>
                Idade:
                <b>{{ item.usuario_idade }} Anos </b>
              </td>
            </tr>
            <tr>
              <td>
                Data de Nascimento:
                <strong v-if="item.adolescente.data_nascimento">
                  {{ item.adolescente.data_nascimento | formatDate }}
                </strong>
              </td>
              <td>
                Naturalidade:
                <strong v-if="item.adolescente.municipio_nascimento">
                  {{ item.adolescente.municipio_nascimento }}-{{
                    getValue(
                      item.adolescente.uf_nascimento,
                      $root.arrays.estados
                    )
                  }}</strong
                >
              </td>
            </tr>
            <tr>
              <td>
                Situação Conjugal:
                <strong v-if="item.adolescente.estado_civil">{{
                  getValue(
                    item.adolescente.estado_civil,
                    $root.arrays.estado_civil
                  )
                }}</strong>
              </td>
              <td>
                Telefone:
                <strong v-if="item.contato"
                  >{{ item.contato.telefone_um }} /
                  {{ item.contato.telefone_dois }}</strong
                >
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Endereço:
                <strong v-if="item.endereco"
                  >{{ item.endereco.logradouro.tipo }}
                  {{ item.endereco.logradouro.nome_logradouro }},
                  {{ item.endereco.numero }}</strong
                >
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Responsável:
                <strong v-if="item.familia_id.responsavel_familiar">{{
                  item.familia_id.responsavel_familiar.nome_completo
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                RG:
                <strong v-if="item.adolescente.documento">{{
                  item.adolescente.documento.rg
                }}</strong>
              </td>
              <td>
                CPF:
                <strong v-if="item.adolescente.documento">{{
                  item.adolescente.documento.cpf | VMask("###.###.##-##")
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2" v-if="item.adolescente.documento">
                Certidão de Nascimento:
                <strong>{{ item.adolescente.documento.termo_certidao }}</strong>
              </td>
            </tr>
            <tr v-if="item.adolescente.documento">
              <td>
                Titulo de Eleitor:
                <strong>{{ item.adolescente.documento.titulo_eleitor }}</strong>
              </td>
              <td>
                Alistamento Militar:
                <strong>{{
                  item.adolescente.documento.alistamento_militar
                }}</strong>
              </td>
            </tr>
            <tr v-if="item.adolescente.documento">
              <td>
                PIS/PASEP:
                <strong>{{ item.adolescente.documento.pis_pasep }}</strong>
              </td>
              <td>
                Carteira do SUS:
                <strong>{{ item.adolescente.documento.cartao_sus }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Composição Familiar</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
          <thead>
            <tr>
              <td colspan="2">
                Constituição Familiar Atual:
                <strong v-if="item.familia_id.constituicao">{{
                  getValue(
                    item.familia_id.constituicao,
                    $root.arrays.constituicao
                  )
                }}</strong>
              </td>
            </tr>
          </thead>
          <tbody
            v-for="(familiar, index) in item.familia_id.familiares"
            :key="index"
          >
            <tr>
              <td>
                Nome:
                <strong>{{ familiar.nome_completo }}</strong>
              </td>
              <td>
                Data Nascimento:
                <strong>{{ familiar.data_nascimento | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Posição Familiar:
                <strong v-if="familiar.posicao_familiar">{{
                  getValue(
                    parseInt(familiar.posicao_familiar),
                    $root.arrays.posicao_familiar
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Profissão:
                <strong v-if="familiar.remuneracao.profissao_nome">{{
                  familiar.remuneracao.profissao_nome
                }}</strong>
              </td>
              <td>
                Renda:
                <strong v-if="familiar.remuneracao.total_rendas"
                  >R$ {{ familiar.remuneracao.total_rendas }}</strong
                >
              </td>
            </tr>
          </tbody>
          <tbody v-if="item.adolescente">
            <tr class="bg-gray">
              <td colspan="2" class="bg-gray text-center">
                <strong>Dados da Situação familiar</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Possui família natural, com vinculação afetiva positiva ?
                <strong>
                  {{
                    item.adolescente.aspecto
                      ? getValue(
                          item.adolescente.aspecto.vinculacao_afetiva_positiva,
                          $root.arrays.pergunta
                        )
                      : ""
                  }}
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Possui família natural, mas não apresenta vinculação afetiva
                positiva ?
                <strong>
                  {{
                    item.adolescente.aspecto
                      ? getValue(
                          item.adolescente.aspecto
                            .familia_natural_sem_vinculacao_afetiva_positiva,
                          $root.arrays.pergunta
                        )
                      : ""
                  }}
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Dispõe de dados sobre a família natural ?
                <strong>
                  {{
                    item.adolescente.aspecto
                      ? getValue(
                          item.adolescente.aspecto.dados_familia_natual,
                          $root.arrays.pergunta
                        )
                      : ""
                  }}
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Há impedimento judicial para contato com a família natural ?
                <strong>
                  {{
                    item.adolescente.aspecto
                      ? getValue(
                          item.adolescente.aspecto.impedimento_judicial,
                          $root.arrays.pergunta
                        )
                      : ""
                  }}
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Está em situação de orfandade ?
                <strong>
                  {{
                    item.adolescente.aspecto
                      ? getValue(
                          item.adolescente.aspecto.situacao_orfandade,
                          $root.arrays.pergunta
                        )
                      : ""
                  }}
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">
          Ato Infracional e Identificação Processual
        </h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.atoInfracional"
        >
          <tbody>
            <tr>
              <td colspan="2">
                Nºdo Processo
                <strong>{{ !!item.numero_processo ? item.numero_processo : 'N/A' }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Ato infracional:
                <strong>{{
                  getValue(
                    item.atoInfracional.ato_infracional,
                    $root.arrays.ato_inflacional
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Tipo de medida: <strong>{{ item.tipo }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Reincidência?
                <strong>{{
                  getValue(
                    item.atoInfracional.reincidencia,
                    $root.arrays.reincidencia
                  )
                }}</strong>
              </td>
              <td>
                Assessoramento Jurídico
                <strong>{{
                  getValue(
                    item.atoInfracional.assessoramento_juridico,
                    $root.arrays.assessoramento_juridico
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="bg-gray text-center">
                <strong> Guia de Execução de Medida Socioeducativa</strong>
              </td>
            </tr>
            <tr>
              <td>
                Número:
                <strong>{{ item.atoInfracional.numero }}</strong>
              </td>
              <td>
                Autos nº
                <strong>{{ item.atoInfracional.autos }}</strong>
              </td>
            </tr>
            <tr v-for="processo in medidasProcessos" :key="processo.id">
              <td>Processos pendentes: <strong>SIM</strong></td>
              <td>
                Autos nº
                <strong>{{
                  processo.ato_infracional
                    ? processo.ato_infracional.numero
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr v-for="finalizada in medidasFinalizadas" :key="finalizada.id">
              <td>Processos medida: <strong>SIM</strong></td>
              <td>
                Técnico de Referência Anterior:
                <strong>{{ finalizada.tecnico.name }}</strong>
              </td>
            </tr>
            <!-- <tr class="bg-danger">
							<td>
								Unificação de medidas: <strong>{{ item.atoInfracional.numero }}</strong>
							</td>
							<td>
								Autos nº <strong>{{ item.atoInfracional.autos }}</strong>
							</td>
						</tr> -->
            <tr>
              <td colspan="2" class="bg-gray text-center">
                <strong>
                  Documentos recebidos referente a MSE em execução e execuções
                  anteriores
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <strong
                  class="mr-2"
                  v-for="(documento, index) in item.atoInfracional
                    .documentos_recebidos"
                  :key="documento.id"
                >
                  <span
                    v-html="
                      getValue(documento, $root.arrays.documentos_recebidos)
                    "
                  ></span>
                  <span
                    v-if="
                      index <
                      item.atoInfracional.documentos_recebidos.length - 1
                    "
                    >,</span
                  >
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <strong>Outros Documentos:</strong>
                <p v-html="item.atoInfracional.outros_documentos"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Histórico Educacional</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.escolaridade"
        >
          <tbody>
            <tr>
              <td>
                Grau de Escolaridade?<strong>{{
                  getValue(
                    item.escolaridade.curso_frequentou,
                    $root.arrays.curso_frequentou
                  )
                }}</strong>
              </td>
              <td>
                Está estudando?
                <strong>{{
                  getValue(
                    item.escolaridade.esta_estudando,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Nome da Escola/Colégio/Faculdade:<strong>{{
                  item.escolaridade.escola_nome
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Último ano/série frequentado?
                <strong>{{
                  getValue(
                    item.escolaridade.ano_serie_frequentou,
                    $root.arrays.ano_serie
                  )
                }}</strong>
              </td>
              <td>
                Frequenta escola?
                <strong>{{
                  getValue(
                    item.escolaridade.frequenta_escola,
                    $root.arrays.frequenta_escola
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Pretende retornar a estudar?
                <strong>{{
                  getValue(
                    item.escolaridade.pretende_retornar,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
              <td>
                Dificuldade de aprendizagem?<strong>{{
                  getValue(
                    item.escolaridade.dificuldade_aprendizagem,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <strong>Observação</strong>
                <p v-html="item.escolaridade.observacoes"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Histórico Habitacionais</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.domicilio"
        >
          <tbody>
            <tr>
              <td colspan="2">
                Condição da moradia?<strong>{{
                  getValue(
                    item.domicilio.tipo_residencia,
                    $root.arrays.tipo_residencia
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Nº de cômodos :<strong>{{
                  item.domicilio.quant_comodos
                }}</strong>
              </td>
              <td>
                Possui banheiro?<strong>{{
                  item.domicilio
                    ? getValue(item.domicilio.banheiro, $root.arrays.pergunta)
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Tipo de construção?<strong>{{
                  item.domicilio
                    ? getValue(
                        item.domicilio.material_paredes,
                        $root.arrays.material_paredes
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Possui energia?<strong>{{
                  item.domicilio
                    ? getValue(
                        item.domicilio.iluminacao,
                        $root.arrays.iluminacao
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Abastecimento de água?<strong>{{
                  item.domicilio
                    ? getValue(
                        item.domicilio.forma_abastecimento_agua,
                        $root.arrays.forma_abastecimento_agua
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Saneamento básico?<strong>{{
                  item.domicilio
                    ? getValue(
                        item.domicilio.forma_escoamento_sanitario,
                        $root.arrays.forma_escoamento_sanitario
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Profissionalização</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.profissionalizacao"
        >
          <tbody>
            <tr>
              <td>
                Está Trabalhando?:
                <strong>{{
                  getValue(
                    item.profissionalizacao.trabalhando,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
              <td>
                Local:
                <strong>{{ item.profissionalizacao.local }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Horário ?:
                <strong>{{ item.profissionalizacao.horario }}</strong>
              </td>
              <td>
                Salário ?:
                <strong>{{ item.profissionalizacao.salario }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Registro em Carteira?:<strong>{{
                  getValue(
                    item.profissionalizacao.registro_carteira,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
              <td>
                Experiências anteriores?<strong>{{
                  getValue(
                    item.profissionalizacao.experiencia_anterior,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Já participou de cursos profissionalizantes?<strong>{{
                  getValue(
                    item.profissionalizacao.participou_cursos,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Quais cursos profissionalizantes realizou?:
                <strong>{{ item.profissionalizacao.qual_curso }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Gostaria de participar de cursos profissionalizantes?:
                <strong>{{
                  getValue(
                    item.profissionalizacao.gostaria_participar,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Quais cursos gostaria de participar?:
                <strong>{{
                  item.profissionalizacao.quais_cursos_gostaria_participar
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Deseja seguir alguma profissão?:
                <strong>{{
                  getValue(
                    item.profissionalizacao.deseja_alguma_profissao,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Qual das profissões de acordo com a CLASSIFICAÇÃO BRASILEIRA DE
                OCUPAÇÕES tem interesse de seguir?:
                <strong>{{
                  getValue(
                    item.profissionalizacao.qual_profissao_interesse,
                    $root.ocupacoes
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Observação sobre as competências profissionais
                identificadas/aptidões:
                <p v-html="item.profissionalizacao.observacoes"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Lazer, Cultura e Esportes</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.lazer"
        >
          <tbody>
            <tr>
              <td>
                Participa de alguma atividade cultural?<strong>{{
                  item.lazer
                    ? getValue(
                        item.lazer.participa_atividade_cultural,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong>{{ item.lazer.qual_atividade_participa }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Gostaria de participar?<strong>{{
                  item.lazer
                    ? getValue(
                        item.lazer.gostaria_participar_atividade,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong>{{
                  item.lazer.qual_atividade_gostaria_participar
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Participa de atividade desportiva?<strong>{{
                  item.lazer
                    ? getValue(
                        item.lazer.participa_atividade_desportiva,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong>{{
                  item.lazer.qual_atividade_desportiva_participa
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Gostaria de participar?<strong>{{
                  item.lazer
                    ? getValue(
                        item.lazer.gostaria_participar_atividade_desportiva,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong>{{
                  item.lazer.qual_atividade_desportiva_gostaria_participar
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <strong>Observação sobre horas livres (lazer)</strong>
                <p v-html="item.lazer.observacoes"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Condições de Saúde</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
          <tbody v-if="item.saude">
            <tr>
              <td>
                Possui questões de saúde?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.portador_doenca,
                        $root.arrays.perguntas
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong v-if="item.saude">{{
                  item.saude.doenca_nome
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Faz algum tratamento?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.faz_tratamento_saude,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong v-if="item.saude">{{
                  item.saude.qual_tratamento_saude
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Faz uso abusivo de álcool?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.uso_abusivo_alcool,
                        $root.arrays.perguntas
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Faz uso de outras drogas?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.uso_abusivo_drogas,
                        $root.arrays.perguntas
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Utiliza algum medicamento?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.uso_remedio_controlado,
                        $root.arrays.perguntas
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Qual?<strong v-if="item.saude">{{
                  item.saude.remedio_controlado_nome
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Já foi internado para tratamento/desintoxicação?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.internado_tratamento,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Período:<strong v-if="item.saude">{{
                  item.saude.periodo_tratamento_saude
                }}</strong>
              </td>
              <td>
                Local?<strong v-if="item.saude">{{
                  item.saude.local_tratamento_saude
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Vida sexual ativa?<strong>{{
                  item.saude
                    ? getValue(item.saude.vida_sexual, $root.arrays.pergunta)
                    : ""
                }}</strong>
              </td>
              <td>
                Quanto tempo?<strong v-if="item.saude">{{
                  item.saude.tempo_vida_sexual
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Faz uso de preservativo ou outro método contraceptivo?<strong>{{
                  item.saude
                    ? getValue(
                        item.saude.uso_preservativo,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Tem parceiro(a) fixo?<strong>{{
                  item.saude
                    ? getValue(item.saude.parceiro_fixo, $root.arrays.pergunta)
                    : ""
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Aspectos SocioFamiliares</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.aspecto"
        >
          <tbody>
            <tr>
              <td colspan="2">
                Avaliação sobre os vínculos familiares?:<strong>{{
                  item.aspecto
                    ? getValue(
                        item.aspecto.vinculacao_afetiva_positiva,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Respeita as regras estabelecidas pelos
                genitores/responsáveis?:<strong>{{
                  item.aspecto
                    ? getValue(
                        item.aspecto.respeita_regra_responsaveis,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Chega tarde da noite em casa?
                <strong>{{
                  item.aspecto
                    ? getValue(
                        item.aspecto.chega_tarde_casa,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
              <td>
                Quanto tempo passa na rua?
                <strong>{{
                  item.aspecto
                    ? getValue(
                        item.aspecto.tempo_na_rua,
                        $root.arrays.tempo_na_rua
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Necessidade de tabela de Horários?
                <strong>{{
                  item.aspecto
                    ? getValue(
                        item.aspecto.tabela_horario,
                        $root.arrays.pergunta
                      )
                    : ""
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <strong
                  >Observação sobre outros vinculos afetivos fora do grupo
                  familiar e participação de grupos sociais</strong
                >
                <p v-if="item.aspecto" v-html="item.aspecto.observacoes"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">
          Vulnerabilidade sociofamiliares
        </h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
          <tbody v-for="vul in vulnerabilidades" :key="vul.id">
            <tr>
              <td colspan="4">
                Violações de Direitos:<strong
                  v-for="(violacoes, index) in vul.violacoes_nomes"
                  :key="index"
                  >{{ violacoes ? violacoes.descricao : "" }}
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Unidade: <strong>{{ vul.unidade.nome }}</strong>
              </td>
            </tr>
            <tr></tr>
            <tr>
              <td colspan="4">
                Status:
                <strong v-html="vul.status_nome"></strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Aspectos da Personalidade</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.pespectiva"
        >
          <tbody>
            <tr>
              <td colspan="4">
                <strong>Tem planos para o futuro?</strong>
                <p v-html="item.pespectiva.planos_futuro"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <strong>A familia corresponde a este interesse?</strong>
                <p v-html="item.pespectiva.familia_corresponde"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <strong
                  >O adolescente recebe algum tipo de apoio ou acolhimento em
                  relação aos interesses e planos para o futuro?</strong
                >
                <p v-html="item.pespectiva.recebe_apoio"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <strong
                  >O adolescente recebe algum tipo de influência negativa em
                  relação aos interesses e planos para o futuro?</strong
                >
                <p v-html="item.pespectiva.recebe_influencia_negativa"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Objetivos / Metas</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.metas"
        >
          <tbody>
            <tr>
              <td colspan="2">
                <h5>Situação Documental</h5>
              </td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.documental_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.documental_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.documental_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h5>Situação Processual</h5></td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.processual_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.processual_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.processual_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h5>Saúde</h5></td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.saude_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.saude_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.saude_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h5>Educação</h5></td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.educacao_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.educacao_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Metal:
                <p v-html="item.metas.educacao_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h5>Profissionalização</h5></td>
              <td colspan="2">
                Prazo:
                <strong>{{
                  item.metas.profissionalizacao_prazo | formatDate
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.profissionalizacao_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.profissionalizacao_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h5>Arte, Cultura, Esporte E Lazer</h5>
              </td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.arte_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.arte_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.arte_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h5>Aspectos Sociofamiliares</h5>
              </td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.aspecto_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.aspecto_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.aspecto_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h5>Condições Socioeconômicas</h5>
              </td>
              <td colspan="2">
                Prazo:
                <strong>{{ item.metas.condicao_prazo | formatDate }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.condicao_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.condicao_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h5>Vulnerabilidade sociofamiliares</h5>
              </td>
              <td colspan="2">
                Prazo:
                <strong>{{
                  item.metas.vulnerabildiade_prazo | formatDate
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual :
                <p v-html="item.metas.vulnerabildiade_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.vulnerabildiade_meta"></p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h5>Preparação para desligamento</h5>
              </td>
              <td colspan="2">
                Prazo:
                <strong>{{
                  item.metas.desligamento_prazo | formatDate
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Situação Atual:
                <p v-html="item.metas.desligamento_situacao_atual"></p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Objetivo/Meta:
                <p v-html="item.metas.desligamento_meta"></p>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="font-weight-bold text-center">Avaliação Final</h5>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          v-if="item.avaliacao"
        >
          <tbody>
            <tr>
              <td>
                Data da Avaliação:
                <strong>{{
                  item.avaliacao.data_avaliacao | formatDate
                }}</strong>
              </td>
              <td>
                Técnico Responsável:
                <strong>{{ item.responsavel.name }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Meses de Acompanhamento:
                <strong>{{ getPrazo(item.criado) }}</strong>
              </td>
              <td>
                Local cumprimento da medida:
                <strong>{{ item.acomp_creas_unidade_nome }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Orientador Social Responsável:<strong>{{
                  item.orientador_social_responsavel_nome
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                As metas e objetivos estabelecidas no PIA foram alcançados?:
                <strong>
                  {{
                    getValue(item.avaliacao.metas_pia, $root.arrays.metas_pia)
                  }}
                </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                O adolescente cumpriu com as condicionalidades estabelecidas no
                Termo de Compromisso?
                <strong>{{
                  getValue(
                    item.avaliacao.cumpriu_condicionalidade,
                    $root.arrays.cumpriu_condicionalidade
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Sobre a disponibilidade do adolescente para realizar as
                atividades propostas:
                <strong>{{
                  getValue(
                    item.avaliacao.disponibilidade_adolescente,
                    $root.arrays.medidas_avaliacao
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Participação no planejamento do seu cronograma de atividades:
                <strong>{{
                  getValue(
                    item.avaliacao.participacao_planejamento,
                    $root.arrays.medidas_avaliacao
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Assiduidade e frequência com que comparece para cumprir a
                prestação de serviços:
                <strong>{{
                  getValue(
                    item.avaliacao.frequencia,
                    $root.arrays.medidas_avaliacao
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Pontualidade:
                <strong>{{
                  getValue(
                    item.avaliacao.pontualidade,
                    $root.arrays.medidas_avaliacao
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Sociabilidade com a equipe e no local de prestação da medida:
                <strong>{{
                  getValue(
                    item.avaliacao.sociabilidade,
                    $root.arrays.medidas_avaliacao
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                A participação da família no processo de cumprimento da medida
                pelo adolescente:
                <strong>{{
                  getValue(
                    item.avaliacao.participacao_cumprimento,
                    $root.arrays.medidas_avaliacao
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <strong
                  >Registre, descritivamente, os principais resultados
                  alcançados, bem como fatores que contribuíram ou dificultaram
                  o alcance dos resultados estabelecidos no PIA:
                </strong>
                <p v-html="item.avaliacao.observacoes"></p>
              </td>
            </tr>
          </tbody>
        </table>

        <print-footer
          v-if="item.responsavel.tecnico.assinatura_digital"
          :tecnico="item.responsavel.tecnico"
          class="mt-0"
          :assinatura="item.responsavel.tecnico.assinatura_digital"
          :wpp="wpp"
          :email="email"
        />

        <span
          class="mr-2"
          v-for="(tecnico, index) in item.outros_tecnicos"
          :key="index"
          v-if="outrasAssinaturas"
        >
          <print-footer
            :tecnico="tecnico"
            class="mt-0"
            :assinatura="tecnico.assinatura_digital"
          />
        </span>

        <p v-if="mode != 'table'" class="text-muted">
          {{ app_cidade }}, {{ app_data_atual }}
        </p>
        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <router-link
              v-if="mode != 'table'"
              :to="`/dashboard/medida/edit/${item.id}?familia_id=${item.familia_id.id}`"
              class="btn btn-default"
            >
              <i class="mdi mdi-arrow-left" />
            </router-link>
            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>
            <form-toggle
              grid="12"
              mt="0"
              v-model="outrasAssinaturas"
              label="Assinatura Técnico (a) Participante"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderMedida from "./HeaderMedida";
export default {
  components: { HeaderMedida },
  props: ["titulo", "mode"],
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      tipos: [],
      tecnicos: [],
      unidades: [],
      vulnerabilidades: [],
      medidasFinalizadas: [],
      medidasProcessos: [],
      outrasAssinaturas: false,
      wpp: true,
      email: true
    };
  },
  mounted() {
    this.getUnidades();
    this.getTipos();
    this.getTecnicos();
    this.getItem();
  },
  methods: {
    getPrazo(data) {
      if (data) {
        var data_final = moment(data);
        var data_atual = moment();
        var prazo = data_final.diff(data_atual, "months");
        return prazo + " mes(es)";
      }
    },
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/medidas/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
        })
        .finally(() => {
          this.loading = false;
          this.getMedidasFinalizadas();
          this.getMedidasprocessos();
          this.getVulnerabilidades();
        })
        .catch((error) => {
          this.$router.push(
            `/dashboard/medidas/${this.$route.query.familia_id}`
          );
        });
    },
    getTecnicos() {
      axios.get(`api/dashboard/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
      });
    },
    getMedidasFinalizadas() {
      axios
        .get(`api/dashboard/medidas/get/finalizadas/${this.item.usuario_id}`)
        .then((response) => {
          this.medidasFinalizadas = response.data;
        });
    },
    getMedidasprocessos() {
      axios
        .get(`api/dashboard/medidas/get/processos/${this.item.usuario_id}`)
        .then((response) => {
          this.medidasProcessos = response.data;
        });
    },
    getTipos() {
      axios.get(`api/dashboard/tipos/medidas`).then((response) => {
        this.tipos = response.data;
      });
    },
    getVulnerabilidades() {
      axios
        .get("api/dashboard/violacaodedireitos", {
          params: {
            id: this.item.familia_id.id,
            status: "EM ACOMPANHAMENTO",
          },
        })
        .then((response) => {
          this.vulnerabilidades = response.data.data;
        });
    },
    getUnidades() {
      axios.get(`api/dashboard/unidades/get/externas`).then((response) => {
        this.unidades = response.data;
      });
    },
    getValue(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");
      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }
      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>
<style>
@media screen {
  #print {
    display: none;
  }
}
@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
